@if (loaded) {

@if(showCheck){
<div fxFlex="100%" class="check">
    <div fxLayout="row" fxLayoutAlign="start center">
        <div fxFlex="30" fxLayout="column">
            <div class="forge-typography--heading1">{{name}}</div>
            <div class="forge-typography--label1">{{variance}}</div>
        </div>

        <div fxFlex="10" fxLayoutAlign="start center" class="icon">
            <forge-icon [name]="icon" [ngStyle]="iconStyle">
            </forge-icon>
        </div>

        <div fxFlex="50">
            <in-balance-chart [check]="check">
            </in-balance-chart>
        </div>

        <div fxFlex="10" fxLayoutAlign="center">
            @if (hasAction)
            {
            <forge-icon-button (click)="view()" aria-label="View">
                <forge-icon name="find_in_page">
                </forge-icon>
                <forge-tooltip placement="bottom">View</forge-tooltip>
            </forge-icon-button>
            }
        </div>
    </div>
</div>
}

}
@else {
<div fxLayout="row" fxLayoutAlign="start center" class="skeleton">
    <forge-skeleton list-item></forge-skeleton>
    <forge-skeleton avatar></forge-skeleton>
    <forge-skeleton list-item></forge-skeleton>
</div>
}
